import React, { FunctionComponent, useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useDataProvider } from 'react-admin';

const withGenerateCategoryGuid = (Component: any): FunctionComponent<any> => {
  const Extension: FunctionComponent<any> = (props) => {
    const { source } = props;
    const form = useForm();
    const { values } = useFormState();
    const dataProvider = useDataProvider();

    const category = values?.[source];
    const currentGuid = values?.guid;
    const status = values?.status;

    useEffect(() => {
      if (status === 'draft') {
        return;
      }
      if (
        category &&
        (category === 'MATCH' || category === 'MB' || category === 'SEO')
      ) {
        if (!currentGuid || !currentGuid.startsWith(`F-KLX-${category}-`)) {
          dataProvider
            .getList('invoices', {
              pagination: { page: 1, perPage: 1 },
              sort: { field: 'id', order: 'DESC' },
              filter: { category: category },
            })
            .then(({ total }: { total: number }) => {
              const nextNumber = (total + 1).toString().padStart(4, '0');
              const generatedGuid = `F-KLX-${category}-${nextNumber}`;

              if (currentGuid !== generatedGuid) {
                form.change('guid', generatedGuid);
              }
            })
            .catch((e: Error) =>
              console.error('Erreur lors du calcul du numéro de facture:', e)
            );
        }
      }
    }, [category, dataProvider, form]);

    return <Component {...props} />;
  };

  return Extension;
};

export default withGenerateCategoryGuid;
